import React from 'react';
import { groupUrlsByRetailerId, RetailerPattern } from '../utils/retailers';

interface ActiveRetailerMatchBarProps {
    urls: string[];
    activeRetailerIdSet: Set<string>;
    retailerPatterns?: RetailerPattern[];
}

const ActiveRetailerMatchBar: React.FC<ActiveRetailerMatchBarProps> = ({ urls, activeRetailerIdSet, retailerPatterns = [] }) => {
    try {
        const unique = Array.from(new Set(urls));
        const domainToUrls = new Map<string, string[]>();
        unique.forEach((u) => {
            try {
                const d = new URL(u).hostname.replace(/^www\./i, '');
                if (!d) return;
                const arr = domainToUrls.get(d) || [];
                arr.push(u);
                domainToUrls.set(d, arr);
            } catch (_e) { }
        });

        const domains: string[] = [];
        domainToUrls.forEach((list, domain) => {
            const allUnknownOrInactive = list.every((u) => {
                const ridMap = groupUrlsByRetailerId([u], retailerPatterns);
                const rid = Object.keys(ridMap)[0];
                return !rid || !activeRetailerIdSet.has(rid);
            });
            if (allUnknownOrInactive) domains.push(domain);
        });

        if (domains.length === 0) return null;

        return (
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 8 }}>
                {domains.map((domain) => (
                    <div
                        key={`unknown:${domain}`}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 6,
                            background: '#FEE2E2',
                            color: '#052849',
                            border: '1px solid #FCA5A5',
                            borderRadius: 16,
                            padding: '6px 10px',
                            fontSize: 12,
                            fontWeight: 400
                        }}
                        title={`${domain} (no active retailer match)`}
                    >
                        {domain}
                    </div>
                ))}
            </div>
        );
    } catch {
        return null;
    }
};

export default ActiveRetailerMatchBar;


